import React from "react";

function Footer() {
  return (
    <div className="footer">
      <footer class="py-1 bg-dark fixed-bottom">
        <div class="container">
          <p class="m-0 text-center text-white">
            Knowing our future by exploring the past! &copy; Phylogeny Explorer Project
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;